import { MunicipalityRepository } from "./municipalityRepository";

/**
 * Serviço de consulta de municípios brasileiros.
 */
export class MunicipalityService {
  private municipalityRepository: MunicipalityRepository;

  constructor(municipalityRepository: MunicipalityRepository) {
    this.municipalityRepository = municipalityRepository;
  }

  /**
   * Delega a busca de municípios por nome ao repositório configurado.
   * @param name Nome ou parte do nome do município
   * @returns Lista de municípios correspondentes
   */
  async findByName(name: string) {
    return await this.municipalityRepository.findByName(name);
  }
}
